import { ApiTokenConsultantResponse, TokenConsultant } from '../interfaces/token.interface';

export const convertTokenConsultantToGet = (data: ApiTokenConsultantResponse): TokenConsultant => {
  return {
    token: data.access_token,
    refreshToken: data.refresh_token,
    tokenExpiryTime: data.created_at + data.expires_in
  };
};
